'use client';

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@shared/components/ui/shadcn/avatar';

type Props = {
  name: string;
  email: string;
  avatarUrl?: string;
};

const getInitials = (name: string) => {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

const UserCard = ({ name, email, avatarUrl }: Props) => {
  return (
    <div
      className="flex items-center gap-3 py-1 font-lato"
      data-testid="user-card"
    >
      <Avatar className="h-6 w-6 bg-card-bg light:bg-hover-press">
        <AvatarImage src={avatarUrl} alt={name} />
        <AvatarFallback className="text-sm font-bold uppercase text-icon bg-card-bg light:bg-hover-press">
          {getInitials(name)}
        </AvatarFallback>
      </Avatar>

      <div className="flex flex-col leading-tight ">
        <span className="text-xs font-medium text-title">{name}</span>
        <span className="text-xs text-subtitle">{email}</span>
      </div>
    </div>
  );
};

export default UserCard;
